export const getUpdatedNewSuggestion = ({ start, end, ...rest }) => ({
  ...rest,
  start: start.toDate(),
  end: end.toDate(),
})
